'use strict';
import React from 'react';

export default class CheckoutSuccess extends React.Component {
    render() {
        return (
            <div className="checkout checkout--success">
                <div className="success__headline">
                    Vielen Dank für Ihre Bestellung
                </div>
                <div className="success__description">
                    <p>
                        Wir haben Ihre Bestellung erhalten und Ihnen eine Bestätigung per E-Mail gesendet.<br />
                        Falls Sie Vorkasse als Versandart gewählt haben, finden Sie nährere Details in der E-Mail.
                    </p>
                    <p>
                        Falls Sie Fragen zu Ihrer Bestellung haben, melden Sie sich einfach unter: <a href="mailto:kontakt@ml-systems.de">kontakt@ml-systems.de</a> oder telefonisch unter:  +49 (0) 791 / 94 67 74-4
                    </p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/success/checkoutSuccess.jsx